<template>
    <toolbar-option type="stacked" :message="message">
        <template slot="primary">
            <dropdown
                :value="value"
                :options="options"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';
import mapFilters from '@/utils/map-filters';

const DEFAULT_VALUE = 'none';

export default {
    name: 'object-fit',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Image Fit',
            message: '* note that changing this option will remove the aspect ratio, if one was set',
            value: DEFAULT_VALUE,
            tailwindDefinitionProp: 'objectFit',
        };
    },

    computed: {
        options() {
            return this.themeObjectValues.map(v => ({ value: v, text: this.titleCase(v) }));
        },
    },

    watch: {
        changedOption({ option }) {
            if (option === 'aspect-ratio') this.onConflict('aspect-ratio');
        },
    },

    methods: {
        ...mapFilters(['titleCase']),

        onInput(valueNew) {
            const flexClassNew = this.addFlexClass({
                value: valueNew,
            });

            this.value = valueNew;
            this.onOptionChange(flexClassNew);
        },

        onSelectedElement() {
            let { value } = this.flexClassDefinition;

            if (!value) {
                value = this.getComputedValue();
            }

            if (this.themeObjectValues.includes(value)) {
                this.value = value;
            } else {
                this.value = DEFAULT_VALUE;
            }
        },

        onConflict(type) {
            switch (type) {
                case 'aspect-ratio':
                    this.value = 'cover';
                    break;

                default:
                    this.value = DEFAULT_VALUE;
            }

            this.removeFlexClass();
        },
    },
};
</script>
